<template>
  <pos-layout>
    <template #clock-right>
      <router-link
        :to="{ name: 'Order', params: { tableID: null, id: 'new' } }"
        class="header-action-btn text-white font-weight-bold text-decoration-none"
        title="New Sale"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line
            x1="12"
            y1="5"
            x2="12"
            y2="19"
          />
          <line
            x1="5"
            y1="12"
            x2="19"
            y2="12"
          />
        </svg>
        <span class="header-action-btn__text">New Sale</span>
      </router-link>
    </template>
    <template #navbar>
      <b-navbar-nav>
        <b-nav-form
          v-if="false"
          on-submit="return false;"
          class="navbar-search"
          autocomplete="off"
          @click.stop
        >
          <label
            for="navbar-search-control-orders"
            @click.prevent
          >
            <svg class="icon icon-icon-search">
              <use xlink:href="#icon-icon-search" />
            </svg>
          </label>
          <form
            @submit.prevent
            @click.stop
          >
            <b-form-input
              id="navbar-search-control-orders"
              ref="searchField"
              v-model="searchQuery"
              placeholder="Search products or orders..."
              autocomplete="off"
              @keyup.enter="handleSearch"
              @click.stop
            />
          </form>
        </b-nav-form>
      </b-navbar-nav>
    </template>

    <div class="h-100 orders">
      <!-- Print panel For mobile -->
      <div class="print d-md-none">
        <b-row class="d-flex h-100 no-gutters">
          <b-col class="h-100 w-100 d-md-none">
            <b-button
              :to="{ name: 'Tables', params: { id: currentOrder.table }}"
              variant="link"
              class="w-100 bg-pink"
            >
              <svg class="icon icon-icon-table">
                <use xlink:href="#icon-icon-table" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-to-tables-mob") }}
              </span>
            </b-button>
          </b-col>

          <b-col class="h-100 w-100">
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-1">
                <use xlink:href="#icon-icon-print-1" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-check") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="currentOrder.status === ORDER_STATUS.REFUNDED"
            class="h-100 w-100"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-2">
                <use xlink:href="#icon-icon-print-2" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.kitchen-print") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="currentOrder.status === ORDER_STATUS.REFUNDED"
            class="h-100 w-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-3">
                <use xlink:href="#icon-icon-print-3" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.open-drawer") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="currentOrder.status !== ORDER_STATUS.CANCELLED"
            class="h-100 w-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-4">
                <use xlink:href="#icon-icon-print-4" />
              </svg>

              <span>
                {{
                  currentOrder.status === ORDER_STATUS.REFUNDED ? $t("amountandpaymentmethod.credit-card") : $t("amountandpaymentmethod.show-payments")
                }}
              </span>
            </b-button>
          </b-col>

          <b-col
            v-if="!sidebarMob"
            class="h-100 w-100 d-md-none"
          >
            <b-button
              variant="link"
              class="w-100 bg-primary"
              @click="sidebarMob = true"
            >
              <svg class="icon icon-icon-mob-view">
                <use xlink:href="#icon-icon-mob-view" />
              </svg>
              <span>
                {{ $t("amountandpaymentmethod.print-view-orders-mob") }}
              </span>
            </b-button>
          </b-col>

          <b-col
            v-if="sidebarMob"
            class="h-100 w-100 d-md-none"
          />
        </b-row>
      </div>

      <b-row class="h-100 no-gutters">
        <b-col
          :class="{hide: sidebarMob}"
          col
          cols="12"
          md="5"
          lg="4"
          class="h-100 orders-sidebar-mob"
        >
          <OrderDetailSidebar
            :order="currentOrder"
            :items="itemsAtCurrentOrder"
            :currency="currency"
            :order-no-text="displayOrderWithTable"
            :show-refund-button="currentOrder.status === ORDER_STATUS.COMPLETED && currentOrder.grand_total !== 0.00"
            :refund-disabled="currentOrder.isFullyRefund || !currentOrder.id || orderHasOnlyGiftCardProduct || isLoading"
            :actions-disabled="isLoading"
            :display-payment-details="displayPaymentDetailsList"
            surcharge-label="Surcharge"
            item-button-class="btn-secondary btn-block"
            :item-key="(item) => item.id"
            :item-name="getItemDisplayName"
            :item-price-text="calculateItemTotalPrice"
            :collapse-visible="showCollapse"
            :collapse-price-text="calculateItemTotalPrice"
            :collapse-discount-text="(item) => calculateItemTotalDiscount(item, currentOrder)"
            :total-text="(o) => formatGrandTotal(o, o.surcharge_value > 0)"
            :discount-total-text="calculateOrderTotalDiscount"
            :surcharge-value-text="(o) => o.surcharge_value.toFixed(2)"
            :balance-text="(o) => o.balance_remaining ? o.balance_remaining.toFixed(2) : '0.00'"
            :print-disabled="(o) => !o.status"
            @refund="showRefundModal"
            @cancel="cancelCurrentOrder"
            @toggle-details="isDisplayPaymentDetailsList"
            @print-check="printCheck()"
          >
            <template #item-modifiers="{ item }">
              <div
                v-for="(modifier, modIndex) in item.modifiers"
                v-if="item.modifiers && item.modifiers.length > 0"
                :key="modIndex"
                class="d-flex align-items-center justify-content-between sub text-nowrap"
              >
                <div class="text-left">
                  {{ modifier.name }}
                </div>
                <div class="text-right">
                  {{ currency }} {{ (modifier.price || modifier.price_original || 0).toFixed(2) }}
                </div>
              </div>
            </template>
            <template #item-discount="{ item }">
              <div
                v-if="item.discount > 0 || (item.wholeDiscount && item.wholeDiscount !== 0) || (currentOrder.discount_orders_raw_value && currentOrder.discount_orders_raw_value > 0)"
                class="d-flex align-items-center justify-content-between sub text-nowrap"
              >
                <div class="text-left">
                  {{ calculateDiscount(item.price, item.discount, item, currentOrder) }} %
                </div>
                <div class="text-right">
                  {{ currency }} {{ calculateItemTotalDiscount(item, currentOrder) }}
                </div>
              </div>
            </template>
          </OrderDetailSidebar>
        </b-col>

        <b-col
          col
          cols="12"
          md="7"
          lg="8"
          class="h-100 orders-col order-list-container"
        >
          <div
            :id="!isMobile && 'infinite-list'"
            class="products-wrap h-100 pt-0"
          >
            <div class="section h-100">
              <div
                :id="isMobile && 'infinite-list'"
                class="section-body"
              >
                <div class="filter">
                  <div class="filter-panel flex-wrap flex-xl-nowrap justify-content-between">
                    <div
                      class="btn-group w-100"
                      role="group"
                    >
                      <b-button
                        :class="{'active': statusFilter==1}"
                        @click="statusFilter=1"
                      >
                        <span>{{ $t("vieworderspopup.open") }}</span>
                      </b-button>
                      <b-button
                        :class="{'active': statusFilter==2}"
                        @click="statusFilter=2"
                      >
                        <span>{{ $t("vieworderspopup.hold") }}</span>
                      </b-button>
                      <b-button
                        :class="{'active': statusFilter==4}"
                        @click="statusFilter=4"
                      >
                        <span>{{ $t("vieworderspopup.cancelled") }}</span>
                      </b-button>
                      <b-button
                        :class="{'active': statusFilter==3}"
                        @click="statusFilter=3"
                      >
                        <span>{{ $t("vieworderspopup.completed") }}</span>
                      </b-button>
                      <b-button
                        :class="{'active': statusFilter==5}"
                        @click="statusFilter=5"
                      >
                        <span>{{ $t("vieworderspopup.refunded") }}</span>
                      </b-button>
                    </div>

                    <div class="d-flex ml-xl-auto align-items-center justify-content-between pt-2 pt-xl-0 w-100">
                      <div class="ml-auto position-relative filter-search d-flex">
                        <input
                          v-model="searchValue"
                          type="text"
                          class="form-control"
                          @keyup.enter="searchByNumber(searchValue)"
                          placeholder="Order #"
                        >
                        <b-button
                          class="active flex-grow-0 flex-shrink-0"
                          @click="searchByNumber(searchValue)"
                        >
                          <span>Search</span>
                        </b-button>
                        <b-button
                          :to="{ name: 'Tables'}"
                          variant="outline-light"
                          class="d-flex align-items-center justify-content-center ml-2 flex-grow-0 flex-shrink-0"
                        >
                          <svg
                            class="mr-2"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <line
                              x1="18"
                              y1="6"
                              x2="6"
                              y2="18"
                            />
                            <line
                              x1="6"
                              y1="6"
                              x2="18"
                              y2="18"
                            />
                          </svg>
                          {{ $t("vieworderspopup.close") }}
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-body">
                    <div class="ol-list">
                      <div
                        v-if="filteredOrders.length === 0 && !isLoading"
                        class="ol-empty text-center text-muted"
                      >
                        No orders available to display.
                      </div>
                      <OrderListCard
                        v-for="(order, index) in filteredOrders"
                        :key="index"
                        :order="order"
                        :currency="currency"
                        :accent-class="accentClass(order)"
                        :selected="isOrderSelected(order)"
                        :id-text="order.id || order.local_id"
                        amount-label="Total"
                        :amount-text="formatGrandTotal(order, order.surcharge_value > 0)"
                        :customer="order.customer || null"
                        :meta-lines="buildMetaLines(order)"
                        :info-cells="buildInfoCells(order)"
                        @card-click="viewOrder(order)"
                      >
                        <template #pills>
                          <span
                            v-if="isOnlineOrder(order)"
                            class="order-source-pill online"
                          >Online Order</span>
                          <span
                            v-if="order.dining_option"
                            class="order-source-pill dining"
                          >{{ order.dining_option }}</span>
                          <span
                            v-if="showPaymentPill(order)"
                            class="ol-status-pill"
                            :class="order.payments && order.payments.length ? 'paid' : 'unpaid'"
                          >
                            {{ order.payments && order.payments.length ? "Paid" : "Unpaid" }}
                          </span>
                        </template>
                        <template #actions>
                          <b-button
                            v-if="order.customer"
                            variant="light"
                            size="sm"
                            class="view-customer-btn"
                            @click="showViewCustomerModal(order.customer)"
                          >
                            View Customer Details
                          </b-button>
                          <b-button
                            variant="light"
                            size="sm"
                            @click="viewOrder(order)"
                          >
                            {{ $t("delegatevieworders.view-order") }}
                          </b-button>
                        </template>
                      </OrderListCard>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <scale-loader
            :loading="isLoad || isProcessing || isTabLoading || isInitialLoading"
            :color="'#007bff'"
          />
        </b-col>
      </b-row>
    </div>
    <SimpleInfoModal :id="'info-modal'">
      <template v-slot:title>
        {{ $t("order.not-found") }}
      </template>
      <template v-slot:info>
        {{ $t("order.not-found") }}. {{ $t("modal-info.try-again") }}
      </template>
    </SimpleInfoModal>
    <ConfirmActionModal
      :modal="confirmActionModal"
      @confirm-action="confirmAction"
    />
    <SuccessActionModal :modal="successActionModal" />
    <CustomerModal
      :view-customer="viewCustomer"
      :is-selected="true"
      @close-modal="clearViewCustomer"
    />
    <ProcessingModal />
    <ModalError
      :id="'modal-error-checkout'"
      :error="error"
    />
  </pos-layout>
</template>

<script>
import { ORDER_STATUS } from "../helpers/order/status";

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import orderMixin from "../mixins/order/orderMixin";
import shiftMixin from "../mixins/shiftMixin";
import viewCustomerModalMixin from "../mixins/modals/viewCustomerModalMixin";
import CustomerModal from "@/modals/CustomerModal";
import SimpleInfoModal from "../components/SimpleInfoModal";
import OrderListCard from "../components/orders/OrderListCard";
import OrderDetailSidebar from "../components/orders/OrderDetailSidebar";
import PosLayout from "../layouts/PosLayout";
import ConfirmActionModal from "../modals/ConfirmActionModal";
import SuccessActionModal from "../modals/SuccessActionModal";
import { TRANSACTION_TYPE } from "@/helpers/order/transaction/types";
import syncMixin from "../mixins/syncMixin";
import printMixin from "../mixins/printMixin";
import ProcessingModal from "../modals/ProcessingModal";
import ModalError from "../modals/ModalError";
import { PAYMENT_BEHAVIOR } from "@/helpers/order/payment/behavior";
import { makeNARefund, makeNAVoid } from "@/helpers/payments/NABancard";
import ScaleLoader from 'vue-spinner/src/ScaleLoader'
import { mapActions, mapGetters } from "vuex";
const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
import { toFixedNoRounding } from "@/helpers/utils";
import { getTimerValue, formatServeAt } from "@/helpers/order/listFormatting";
import { checkForSKU } from "@/helpers/order/barcode";
import { resolveItemDisplayName } from "@/services/order/orderDomain";

export default {
  name: "OrderList",
  components: {
    PosLayout,
    SimpleInfoModal,
    OrderListCard,
    OrderDetailSidebar,
    ScaleLoader,
    ConfirmActionModal,
    SuccessActionModal,
    CustomerModal,
    ProcessingModal,
    ModalError
  },
  mixins: [orderMixin, shiftMixin, viewCustomerModalMixin, syncMixin, printMixin],
  data () {
    return {
      sidebarMob: true,
      timer: 0,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: true,
        slideToClickedSlide: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      currentCategory: 2,
      storeInfo: null,
      itemIdCounter: 0,
      currentOrder: {
        id: 0,
        localID: 0,
        subtotal: 0,
        tax_total: 0,
        grand_total: 0,
        items: [],
        table: null,
        status: null,
        // order_gift_card_payment:[]
      },
      modalShow: false,
      bodyBgVariant: "light",
      popupPrice: ["popup-price"],
      popupPriceSidebar: ["popup-price-sidebar"],
      statusFilter: 3,
      ORDER_STATUS: ORDER_STATUS,
      displayPaymentDetailsList: false,
      searchValue: "",
      searchQuery: "",
      perPage: 20,
      countItems: 20,
      infoModal: {
        text: "Not Found"
      },
      confirmActionModal: {
        title: "",
        text: "",
        confirmActionText: "refund"
      },
      actionToConfirm: "",
      successActionModal: {
        title: "Success",
        text: "Order has been refunded"
      },
      isProcessing: false,
      error: {
        title: "Unknown error...",
        info: "Please, contact support"
      },
      isScrolled: false, // used to control the refreshing of the order display
      isTabLoading: false, // used to show loader when switching tabs
      isInitialLoading: false, // used to show loader during initial page load
      nanSyncTimeout: null,
      // Teardown handles so listeners/timers created in mounted() are always
      // removed in beforeDestroy() (Phase 5 leak fixes).
      startupTimer: null,
      scrollContainer: null,
      onScrollHandler: null
    };
  },
  computed: {
    ...mapGetters({
      shouldDeductQuantity: 'orders/shouldDeductQuantity',
      orderList: 'orders/orderList',
      refundedOrdersList:"orders/refundedOrdersList",
      showSelectedOrder:"orders/showSelectedOrder",
      getTableById: 'config/getTableById',
      products: 'config/products',
      currency: 'config/currency'
    }),
    isRealtimeActive () {
      const realtime = this.$store.state.realtime;
      return !!(realtime && realtime.isConnected && !realtime.isDisabled);
    },
    isLoading() {
      return this.isLoad || this.isProcessing || this.isTabLoading || this.isInitialLoading;
    },
    // Pure computed: derives the visible, sorted, paginated order list from the
    // store. Phase 5 moved the previous side effects (resetting/selecting
    // currentOrder, mutating store objects with isFullyRefund) out of here and
    // into the `filteredOrders` watcher + `applyRefundStatus` helper so the
    // computed no longer mutates state. Observable behavior is preserved.
    filteredOrders: function () {
      const self = this;

      // Choose base collection depending on whether realtime is active.
      // When using API results, local IndexedDB orders still win because the
      // queue/API can lag behind a local close/cancel/payment.
      const mergeLocalOverRemote = (remoteOrders, localOrders) => {
        const localKeys = new Set();
        localOrders.forEach(order => {
          if (order.local_id) localKeys.add(`local:${order.local_id}`);
          if (order.id) localKeys.add(`id:${order.id}`);
        });

        const remoteWithoutLocalCopies = remoteOrders.filter(order => {
          const hasLocalCopy = (order.local_id && localKeys.has(`local:${order.local_id}`)) ||
            (order.id && localKeys.has(`id:${order.id}`));
          return !hasLocalCopy;
        });

        return [...remoteWithoutLocalCopies, ...localOrders]
          .filter((order) => order.status === self.statusFilter);
      };

      let orders = [];
      if (this.isRealtimeActive) {
        orders = this.orders.filter((order) => order.status === self.statusFilter);
      } else {
        orders = mergeLocalOverRemote(
          this.orderList,
          this.orders
        );
      }

      return orders
        .slice()
        .sort((a, b) => b.id - a.id)
        .slice(0, this.countItems);
    },
    orders: function () {
      return this.$store.getters["orders/getAllOrders"];
    },
    currentShift: function () {
      return this.$store.getters["shift"];
    },
    isLoad: function () {
      return this.$store.getters["orders/isLoad"];
    },
    isMobile: function () {
      return window.innerWidth <= 992;
    },
    store () {
      return this.$store.getters["config/store"];
    },
    // Gift-card product id is per-store configurable (Store.gift_card,
    // default -2); never hardcode -2. Number() guards a string id.
    giftCardProductId () {
      const id = this.store && this.store.gift_card != null ? this.store.gift_card : -2;
      return Number(id);
    },
    terminal () {
      return this.$store.getters["config/terminal"];
    },
    currency () {
      return this.$store.getters["config/currency"];
    },
    orderHasOnlyGiftCardProduct(){
      const void_status = this.currentOrder.items.map(item => item.void_status).every(item => item === null)
      if (!void_status) return this.currentOrder.items.filter(item => item.void_status === 0).every(item=>item.product === -2);
      else return false;
    },
    displayOrderWithTable() {
      const orderId = this.currentOrder.id || this.currentOrder.local_id;

      // If order has a table, get the table name
      if (this.currentOrder.table && this.getTableById) {
        const table = this.getTableById(this.currentOrder.table);
        if (table && table.table_name) {
          return `${table.table_name} / ${orderId}`;
        }
      }

      return orderId;
    },
    isReceiptSearchEnabled() {
      // Check if search_receipt db_setting is true (disabled by default)
      if (this.terminal && this.terminal.db_settings) {
        const searchReceiptSetting = this.terminal.db_settings.find(setting => setting.name === 'search_receipt');
        return searchReceiptSetting ? searchReceiptSetting.value === 'true' : false;
      }
      return false;
    }
  },
  watch: {
    statusFilter(status) {
      this.$store.dispatch("setLastStatus", { status });
      this.setSelectedOrder(null);
      this.isScrolled = false;
      this.countItems = this.perPage;

      const connection = this.$store.getters["connection"];
      if (connection) {
        const payload = {
          orderStatus: status,
          firstPage: 1,
          initial: true
        };
        this.fetchOrderListByStatus(payload);
      }
    },
    searchValue (value, prevValue) {
      const idRegex = "^[0-9_]*$";
      if (value.search(idRegex) === -1) this.searchValue = prevValue;
    },
    // Selects/clears the preview order whenever the visible list changes. This
    // replaces the side effects that previously lived inside the filteredOrders
    // computed: while the user has not scrolled, the first (or store-selected)
    // order is previewed; an empty list resets the preview.
    filteredOrders: {
      handler (list) {
        if (this.isScrolled) return;
        if (list && list.length > 0) {
          let selected = this.showSelectedOrder
            ? this.$store.getters["orders/getOrderByIdOrLocalId"](this.showSelectedOrder)
            : list[0];
          if (selected && selected.status === ORDER_STATUS.COMPLETED) {
            selected = this.applyRefundStatus(selected);
          }
          this.currentOrder = selected;
        } else {
          this.resetCurrentOrder();
        }
      },
      immediate: true
    },
    // Keep the preview order (currentOrder) in sync with Vuex when orders
    // are updated via realtime or other background mechanisms.
    orders: {
      handler () {
        if (!this.currentOrder) return;
        const identifier = this.currentOrder.id || this.currentOrder.local_id;
        if (!identifier) return;
        let fresh = this.$store.getters["orders/getOrderByIdOrLocalId"](identifier);
        if (fresh) {
          if (fresh.status === ORDER_STATUS.COMPLETED) {
            fresh = this.applyRefundStatus(fresh);
          }
          this.currentOrder = fresh;
        }
      },
      deep: true
    },
    '$route.query.orderId': {
      async handler(newOrderId, oldOrderId) {
        // Watch for changes to orderId query parameter
        if (newOrderId && newOrderId !== oldOrderId) {
          const orderId = parseInt(newOrderId);
          // Find the order in orderList or orders
          let order = this.orderList.find(o => o.id === orderId);
          if (!order) {
            order = this.orders.find(o => o.id === orderId || o.local_id === orderId);
          }
          if (order) {
            // Switch to the correct status tab if needed
            if (order.status !== this.statusFilter) {
              this.statusFilter = order.status;
              // Wait for the status filter change to complete and data to load
              await this.$nextTick();
              // Give it a bit more time for the data to be ready
              setTimeout(() => {
                this.viewOrder(order);
              }, 300);
            } else {
              // Same status, just view the order
              this.$nextTick(() => {
                this.viewOrder(order);
              });
            }
          }
        }
      },
      immediate: false
    }
  },
  async created() {
    try {
      this.isInitialLoading = true;
      if (this.orderList.length === 0 || this.orders.length === 0) {
        await this.fetchOrdersFromDb();
      }
      const savedStatus = this.$store?.state?.orderList?.lastStatus;
      const allowedStatuses = [1, 2, 3, 4, 5];
      if (allowedStatuses.includes(savedStatus)) {
        this.statusFilter = savedStatus;
      }
      if ("serviceWorker" in navigator)
        navigator.serviceWorker.addEventListener("message", this.receiveMessage);
    } finally {
      this.isInitialLoading = false;
    }
  },
  mounted () {
    this.isInitialLoading = true;
    this.startTimer();

    const connection = this.$store.getters["connection"];
    if (connection) {
      const payload = {
        orderStatus: this.statusFilter,
        initial: true
      };
      this.fetchOrderListByStatus(payload);
    }
    this.isInitialLoading = false;

    // Check if orderId query parameter exists and view that order
    if (this.$route.query.orderId) {
      const orderId = parseInt(this.$route.query.orderId);
      this.$nextTick(() => {
        // Find the order in orderList or orders (check all orders, not just filtered)
        let order = this.orderList.find(o => o.id === orderId);
        if (!order) {
          order = this.orders.find(o => o.id === orderId || o.local_id === orderId);
        }
        if (order) {
          // Switch to the correct status tab if needed
          if (order.status !== this.statusFilter) {
            this.statusFilter = order.status;
          }
          this.viewOrder(order);
        }
      });
    }

    // Add keyboard event listener to auto-focus search field
    document.addEventListener('keypress', this.onKeyPress);

    const container = document.querySelector("#infinite-list");
    const self = this;
    if (container) {
      // Store both the element and the handler so beforeDestroy can detach it
      // (previously this listener was never removed -> leak on every revisit).
      this.scrollContainer = container;
      this.onScrollHandler = function () {
        if (self.isLoad) return false;
        const userScrollHeight = container.scrollTop + container.clientHeight;
        const threshold = userScrollHeight + container.scrollHeight * 0.2;
        if (threshold - container.scrollHeight > -2) {
          // setting the boolean so it does not updates the currentOrder
          self.isScrolled = true
          // Rely on Ably only – no API orderlist fetch on scroll. Client-side
          // pagination only: reveal another page of already-loaded orders.
          self.countItems = self.countItems + self.perPage;
        }
      };
      container.addEventListener("scroll", this.onScrollHandler);
    }
  },
  beforeDestroy () {
    // if ("serviceWorker" in navigator)
    //   navigator.serviceWorker.removeEventListener("message", this.receiveMessage);

    // Remove keyboard event listener
    document.removeEventListener('keypress', this.onKeyPress);

    // Detach the infinite-scroll listener (Phase 5 leak fix).
    if (this.scrollContainer && this.onScrollHandler) {
      this.scrollContainer.removeEventListener("scroll", this.onScrollHandler);
      this.scrollContainer = null;
      this.onScrollHandler = null;
    }

    // Clear the startup interval if it is still running (Phase 5 leak fix).
    if (this.startupTimer) {
      clearInterval(this.startupTimer);
      this.startupTimer = null;
    }

    // Defensive: clear the NaN-resync timeout if one is ever pending.
    if (this.nanSyncTimeout) {
      clearTimeout(this.nanSyncTimeout);
      this.nanSyncTimeout = null;
    }

    this.$store.dispatch("resetPageCounterForAll");

    // nullify the selected order on change of status selection
    this.setSelectedOrder(null)
  },
  methods: {
    ...mapActions('orders',
    [
      'setRefundItems',
      'setRefundOrderId',
      'setDeductRefundQuantity',
      'setRefundOrderTableId',
      'fetchOrderListByStatus',
      'emptyOrderList',
      'fetchOrderById',
      'setRefundedOrderTotalDiscount',
      'fetchOrdersFromDb',
      'setSelectedOrder'
  ]),
  toFixedNoRounding,
    // Shared pure list helpers (see helpers/order/listFormatting.js)
    getTimerValue,
    formatServeAt,
    isOnlineOrder (order) {
      return !!(order && order.type === 1);
    },
    accentClass (order) {
      switch (order.status) {
        case ORDER_STATUS.OPEN: return "accent-open";
        case ORDER_STATUS.HOLD: return "accent-hold";
        case ORDER_STATUS.COMPLETED: return "accent-completed";
        case ORDER_STATUS.CANCELLED: return "accent-cancelled";
        case ORDER_STATUS.REFUNDED: return "accent-refunded";
        default: return "";
      }
    },
    showPaymentPill (order) {
      return order.status === ORDER_STATUS.OPEN || this.isOnlineOrder(order);
    },
    getTableName (order) {
      if (!order.table || !this.getTableById) return "";
      const table = this.getTableById(order.table);
      return table && table.table_name ? table.table_name : "";
    },
    getItemCount (order) {
      if (!order.items || !Array.isArray(order.items)) return 0;
      if (order.status === ORDER_STATUS.CANCELLED) return order.items.length;
      return order.items.filter(item => item.void_status === 0 || item.void_status === null).length;
    },
    // Builds the props-down meta-line array for the shared OrderListCard.
    // Mirrors the original inline `ol-meta-line` markup exactly.
    buildMetaLines (order) {
      const lines = [];
      const tableName = this.getTableName(order);
      if (tableName) lines.push({ text: `Table: ${tableName}`, className: "ol-meta-line" });
      if (order.delivery_address) lines.push({ text: order.delivery_address, className: "ol-meta-line" });
      if (order.status === ORDER_STATUS.HOLD && order.description) {
        lines.push({ text: `Hold Note: ${order.description}`, className: "ol-meta-line hold" });
      }
      return lines;
    },
    // Builds the props-down info-cell array for the shared OrderListCard.
    // Mirrors the original inline `ol-info-cell` markup exactly (order matters).
    buildInfoCells (order) {
      const cells = [];
      if (this.isOnlineOrder(order)) {
        cells.push({ label: "Serve at", value: this.formatServeAt(order.serve_at), valueClass: "serve" });
      }
      cells.push({ label: this.getOrderDateLabel(order), value: this.getOrderDateValue(order) });
      cells.push({ label: "Time Elapsed", value: this.getTimerValue(order.open_date, this.getOrderEndDate(order)) });
      cells.push({ label: "Items", value: this.getItemCount(order) });
      if (order.employee && order.employee.name) {
        cells.push({ label: "Employee", value: order.employee.name });
      }
      return cells;
    },
    getOrderDateLabel (order) {
      if (order.status === ORDER_STATUS.HOLD) return "Held";
      if (order.status === ORDER_STATUS.COMPLETED || order.status === ORDER_STATUS.CANCELLED || order.status === ORDER_STATUS.REFUNDED) {
        return "Closed";
      }
      return "Opened";
    },
    getOrderDateValue (order) {
      if (order.status === ORDER_STATUS.HOLD) {
        return this.convertDate(order.hold_date || order.open_date);
      }
      if (order.status === ORDER_STATUS.COMPLETED || order.status === ORDER_STATUS.CANCELLED || order.status === ORDER_STATUS.REFUNDED) {
        return this.convertDate(order.close_date);
      }
      return this.convertDate(order.open_date);
    },
    getOrderEndDate (order) {
      if (order.status === ORDER_STATUS.COMPLETED || order.status === ORDER_STATUS.CANCELLED || order.status === ORDER_STATUS.REFUNDED) {
        return order.close_date;
      }
      return null;
    },
    async cancelCurrentOrder () {
      const identifier = this.currentOrder?.id || this.currentOrder?.local_id;
      if (!identifier) return;

      let fullOrder = this.$store.getters["orders/getOrderByIdOrLocalId"](identifier);

      // Server lookup disabled - only use local order data when cancelling
      // if (!hasUsableItems && this.currentOrder?.id && navigator.onLine) {
      //   try {
      //     const fetchedOrder = await this.fetchOrderById(this.currentOrder.id);
      //     if (fetchedOrder) {
      //       await this.$store.commit("orders/saveOrder", fetchedOrder);
      //       fullOrder = this.$store.getters["orders/getOrderByIdOrLocalId"](fetchedOrder.id) || fetchedOrder;
      //     }
      //   } catch (error) {
      //     console.error("[OrdersList] Failed to fetch full order before cancel:", error);
      //   }
      // }

      if (!fullOrder) fullOrder = { ...this.currentOrder };

      // API-backed list rows can be the only copy of an order in /orders.
      // Pin a local clone before opening the async confirmation/cancel flow so
      // computed list refreshes cannot replace currentOrder mid-cancel.
      fullOrder = JSON.parse(JSON.stringify(fullOrder));
      fullOrder.local_id = fullOrder.local_id || fullOrder.id;
      fullOrder.items = Array.isArray(fullOrder.items) ? fullOrder.items : [];
      fullOrder.payments = Array.isArray(fullOrder.payments) ? fullOrder.payments : [];
      if (fullOrder.id) {
        fullOrder.number = fullOrder.id.toString();
      }

      const previousOrder = this.currentOrder;
      let cancelled = false;
      const wasScrolled = this.isScrolled;
      this.isScrolled = true;
      this.currentOrder = fullOrder;
      try {
        // Void-reason modal doubles as the confirmation when reasons are
        // configured (see confirmOrderCancel in orderMixin).
        const { confirmed, voidReason } = await this.confirmOrderCancel();
        if (!confirmed) return;
        this.setSelectedOrder(identifier);
        await this.cancelOrderProcessing({ voidReason });
        cancelled = true;
      } finally {
        if (!cancelled) {
          this.currentOrder = previousOrder;
        }
        this.isScrolled = wasScrolled;
        this.setSelectedOrder(null);
      }
    },
    // Helper method to safely format grand_total - handles NaN, undefined, null
    formatGrandTotal(order, includeSurcharge = false) {
      let gt = order ? order.grand_total : 0;
      // Handle all NaN cases
      if (gt === undefined || gt === null || gt === '' || (typeof gt === 'number' && isNaN(gt)) || (typeof gt === 'string' && gt === 'NaN')) {
        gt = 0;
      }
      gt = parseFloat(gt);
      if (isNaN(gt)) gt = 0;

      if (includeSurcharge && order && order.surcharge_value > 0) {
        let surcharge = order.surcharge_value;
        if (isNaN(surcharge)) surcharge = 0;
        gt += surcharge;
      }
      return gt.toFixed(2);
    },
    onKeyPress() {
      // Auto-focus search field when user starts typing
      try {
        if (this.$refs.searchField) {
          this.$refs.searchField.focus();
        }
      } catch (e) {
        // Ignore errors
      }
    },
    async handleSearch() {
      if (!this.searchQuery || this.searchQuery.trim() === "") {
        return;
      }

      const searchValue = this.searchQuery.trim();

      // Always search for products first (even if numeric - could be barcode)
      let products = this.searchProductByName(searchValue);

      // If no products found, try SKU breakdown
      if (products.length === 0) {
        const skuResult = this.checkForSKU(searchValue);
        products = this.searchProductByName(skuResult?.value);
      }

      const product = products.length > 0 ? products[0] : null;

      // Only check for order if receipt search is enabled
      const numericValue = parseInt(searchValue);
      let order = null;
      if (this.isReceiptSearchEnabled && !isNaN(numericValue) && searchValue === numericValue.toString()) {
        // Check if order exists in local store
        order = this.$store.getters["orders/getOrderByIdOrLocalId"](numericValue);

        // If not found locally, try fetching from backend (commented out - server lookup disabled)
        // if (!order) {
        //   try {
        //     this.isProcessing = true;
        //     order = await this.fetchOrderById(numericValue);
        //     this.isProcessing = false;
        //   } catch (error) {
        //     this.isProcessing = false;
        //     order = null;
        //   }
        // }
      }

      // Now decide what to show based on what was found
      if (product && order) {
        // Both found - show combined dialog
        this.showProductAndOrderFoundDialog(product, order);
      } else if (product) {
        // Only product found
        this.showProductFoundDialog(product);
      } else if (order) {
        // Only order found
        this.showOrderFoundDialog(order);
      } else {
        // Nothing found - show error
        this.searchQuery = "";
        const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
        sound.play();
        this.$bvModal.show("simple-info-modal");
      }
    },
    searchProductByName(textToSearch) {
      const searchTerm = textToSearch.toLowerCase().trim();
      return this.products.filter(product => {
        // Gift cards are never searchable — they can only be added via
        // "More Options" > Gift Card. Guard covers name and barcode below.
        // Keyed off the store's configured gift-card id, not a hardcoded -2.
        if (Number(product.id) === this.giftCardProductId) {
          return false;
        }
        // Search by name - partial match allowed
        if (product.name.toLowerCase().includes(searchTerm)) {
          return product;
        }
        // Search by barcode - EXACT match only
        if (product.barcode && product.barcode.toLowerCase() === searchTerm) {
          return product;
        }
        return false;
      });
    },
    checkForSKU(barcode) {
      // Pure barcode/SKU parser extracted to helpers/order/barcode (Step 2).
      return checkForSKU(barcode);
    },
    async searchOrderByIdWithFallback(searchValue) {
      const orderId = parseInt(searchValue);

      try {
        // First check if order exists in local store
        let order = this.$store.getters["orders/getOrderByIdOrLocalId"](orderId);

        // If not found locally, try fetching from backend (commented out - server lookup disabled)
        // if (!order) {
        //   this.isProcessing = true;
        //   order = await this.fetchOrderById(orderId);
        //   this.isProcessing = false;
        // }

        if (order && order.id) {
          // Order found - show dialog asking to navigate
          const self = this;
          const messageVNode = this.$createElement("div", {
            domProps: {
              innerHTML: `
                <div class="success-popup-body">
                  <svg class="icon icon-icon-check-circle" style="width: 48px; height: 48px; color: #28a745;">
                    <use xlink:href="#icon-icon-check-circle" />
                  </svg>
                  <h5>Order #${order.number || order.id} Found</h5>
                  <p>Would you like to navigate to this order?</p>
                </div>
              `
            }
          });

          this.$bvModal.msgBoxConfirm([messageVNode], {
            title: [],
            centered: true,
            modalClass: "success-popup",
            hideHeader: true,
            footerClass: "d-flex justify-content-center align-items-center",
            okVariant: "primary",
            okTitle: "YES, GO TO ORDER",
            cancelVariant: "outline-secondary",
            cancelTitle: "CANCEL",
            noFade: true
          }).then(function (result) {
            self.searchQuery = "";
            if (result) {
              // Navigate to existing order
              self.viewOrder(order);
            }
            // If cancelled, just clear search - no action needed
          }).catch(function () {
            self.searchQuery = "";
          });
        } else {
          // Order not found - show error with proper message
          this.searchQuery = "";

          const messageVNode = this.$createElement("div", {
            domProps: {
              innerHTML: `
                <div class="success-popup-body">
                  <svg class="icon icon-icon-times-circle" style="width: 48px; height: 48px; color: #dc3545;">
                    <use xlink:href="#icon-icon-times-circle" />
                  </svg>
                  <h5>Order Not Found</h5>
                  <p>No order found with ID: ${orderId}</p>
                </div>
              `
            }
          });

          this.$bvModal.msgBoxOk([messageVNode], {
            title: [],
            centered: true,
            modalClass: "error-popup",
            hideHeader: true,
            footerClass: "d-flex justify-content-center align-items-center",
            okVariant: "secondary",
            okTitle: "OK",
            noFade: true
          }).catch(() => {
            // Handle modal destroyed before resolve
          });

          const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
          sound.play();
        }
      } catch (error) {
        console.error("[searchOrderByIdWithFallback] Error searching for order:", error);
        this.isProcessing = false;
        this.searchQuery = "";

        const messageVNode = this.$createElement("div", {
          domProps: {
            innerHTML: `
              <div class="success-popup-body">
                <svg class="icon icon-icon-times-circle" style="width: 48px; height: 48px; color: #dc3545;">
                  <use xlink:href="#icon-icon-times-circle" />
                </svg>
                <h5>Error</h5>
                <p>An error occurred while searching for the order.</p>
              </div>
            `
          }
        });

        this.$bvModal.msgBoxOk([messageVNode], {
          title: [],
          centered: true,
          modalClass: "error-popup",
          hideHeader: true,
          footerClass: "d-flex justify-content-center align-items-center",
          okVariant: "secondary",
          okTitle: "OK",
          noFade: true
        }).catch(() => {
          // Handle modal destroyed before resolve
        });

        const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
        sound.play();
      }
    },
    showProductFoundDialog(product) {
      const self = this;
      const messageVNode = this.$createElement("div", {
        domProps: {
          innerHTML: `
            <div class="success-popup-body">
              <h5>Product Found</h5>
              <p><strong>${product.name}</strong></p>
              <p>${this.currency} ${product.price.toFixed(2)}</p>
              <p>Would you like to create a new order and add this product?</p>
            </div>
          `
        }
      });

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: [],
        centered: true,
        modalClass: "success-popup",
        hideHeader: true,
        footerClass: "d-flex justify-content-center align-items-center",
        cancelVariant: "outline-secondary",
        okVariant: "primary",
        okTitle: "YES, CREATE ORDER",
        cancelTitle: "CANCEL",
        noFade: true
      }).then(function (result) {
        if (result) {
          // Clear search and navigate to new order with product
          self.searchQuery = "";
          self.$router.push({
            name: "Order",
            params: { id: "new" },
            query: { productId: product.id }
          });
        } else {
          // Just clear the search
          self.searchQuery = "";
        }
      }).catch(function () {
        self.searchQuery = "";
      });
    },
    showProductAndOrderFoundDialog(product, order) {
      // Both product and order found - show combined dialog
      const self = this;
      const messageVNode = this.$createElement("div", {
        domProps: {
          innerHTML: `
            <div class="success-popup-body">
              <h5>Product & Order Found</h5>
              <p><strong>Product:</strong> ${product.name} (${this.currency}${product.price.toFixed(2)})</p>
              <p><strong>Order:</strong> #${order.number || order.id}</p>
              <p>What would you like to do?</p>
            </div>
          `
        }
      });

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: [],
        centered: true,
        modalClass: "success-popup",
        hideHeader: true,
        footerClass: "d-flex justify-content-center align-items-center",
        okVariant: "primary",
        okTitle: "CREATE ORDER WITH PRODUCT",
        cancelVariant: "outline-primary",
        cancelTitle: "GO TO ORDER #" + (order.number || order.id),
        noFade: true
      }).then(function (result) {
        self.searchQuery = "";
        if (result) {
          // Create new order with product
          self.$router.push({
            name: "Order",
            params: { id: "new" },
            query: { productId: product.id }
          });
        } else {
          // Navigate to existing order
          self.viewOrder(order);
        }
      }).catch(function () {
        self.searchQuery = "";
      });
    },
    showOrderFoundDialog(order) {
      // Only order found (no product) - show simple navigation dialog
      const self = this;
      const messageVNode = this.$createElement("div", {
        domProps: {
          innerHTML: `
            <div class="success-popup-body">
              <svg class="icon icon-icon-check-circle" style="width: 48px; height: 48px; color: #28a745;">
                <use xlink:href="#icon-icon-check-circle" />
              </svg>
              <h5>Order #${order.number || order.id} Found</h5>
              <p>Would you like to navigate to this order?</p>
            </div>
          `
        }
      });

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: [],
        centered: true,
        modalClass: "success-popup",
        hideHeader: true,
        footerClass: "d-flex justify-content-center align-items-center",
        okVariant: "primary",
        okTitle: "YES, GO TO ORDER",
        cancelVariant: "outline-secondary",
        cancelTitle: "CANCEL",
        noFade: true
      }).then(function (result) {
        self.searchQuery = "";
        if (result) {
          self.viewOrder(order);
        }
      }).catch(function () {
        self.searchQuery = "";
      });
    },
    async searchOrderById(searchValue) {
      const orderId = parseInt(searchValue);
      if (isNaN(orderId)) {
        // Not a valid order ID, show not found
        this.searchQuery = "";
        const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
        sound.play();
        this.$bvModal.show("simple-info-modal");
        return;
      }

      try {
        // First check if order exists in local store
        let order = this.$store.getters["orders/getOrderByIdOrLocalId"](orderId);

        // If not found locally, try fetching from backend (commented out - server lookup disabled)
        // if (!order) {
        //   this.isLoad = true;
        //   order = await this.fetchOrderById(orderId);
        //   this.isLoad = false;
        // }

        if (order && order.id) {
          // Order found - view it
          this.searchQuery = "";
          this.viewOrder(order);
        } else {
          // Order not found
          this.searchQuery = "";
          const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
          sound.play();
          this.$bvModal.show("simple-info-modal");
        }
      } catch (error) {
        console.error("[searchOrderById] Error searching for order:", error);
        this.isLoad = false;
        this.searchQuery = "";
        const sound = new Audio(require("../assets/sounds/error-sound.mp3"));
        sound.play();
        this.$bvModal.show("simple-info-modal");
      }
    },
    confirmAction (value) {
      if (!value) return false;
      this[this.actionToConfirm]();
      this.$bvModal.hide("confirm-action--modal");
    },
    showRefundModal() {
      const self = this
      let orderToBeRefunded = { ...this.currentOrder }
      // checking if the refunded order was previously made through gift card
      if(orderToBeRefunded?.order_gift_card_payment?.length){
        this.setRefundGiftCardIds(
            (orderToBeRefunded?.order_gift_card_payment || [])
                .map(gift_card_payment => gift_card_payment?.gift_card_number)
        )
      }
      orderToBeRefunded.items.forEach(item=>item.duplicateQuantity = item.quantity)
      let refundedOrders = self.refundedOrdersList.filter(refundedOrders => refundedOrders.reference_order === orderToBeRefunded.id)
      let offlineRefundedOrders = this.orders.filter((order) => {
        if (!order.id) {
          return order.status === ORDER_STATUS.REFUNDED && order.reference_order === orderToBeRefunded.id
        }
      })
      refundedOrders.push(...offlineRefundedOrders)
      if (refundedOrders.length > 0) {
      refundedOrders.forEach(refundedOrder => {
        orderToBeRefunded.items.forEach((orderToBeRefundedItems,itemIndex) => {
        const item = refundedOrder.items.filter(refundedOrderItem => refundedOrderItem.order_refund_item === orderToBeRefundedItems.id)

          if (item.length > 0 && item[0].void_item) {
            orderToBeRefunded.items[itemIndex].duplicateQuantity += item[0].quantity
          }
        })
      })
    }

    // Filter out items that have been fully refunded (duplicateQuantity <= 0) or are gift cards
    const itemsAvailableForRefund = orderToBeRefunded.items.filter(item =>
      item.product !== -2 && item.duplicateQuantity > 0
    );

    // Check if there are any items left to refund
    if (itemsAvailableForRefund.length === 0) {
      // Show message that order is fully refunded
      this.$bvToast.toast('All items in this order have been fully refunded.', {
        title: 'No Items to Refund',
        variant: 'warning',
        solid: true,
        autoHideDelay: 3000
      });
      return;
    }

    // saving the attributes which calculates discount total for the refunded order of the reference order
    const discountTotalDetails = {
      value: this.currentOrder.discount_orders_raw_value,
      discountType: this.currentOrder.discount_orders_raw_type

    }
    // Set only items that can still be refunded
    this.setRefundItems(itemsAvailableForRefund)
    // stroing in store
    this.setRefundedOrderTotalDiscount(discountTotalDetails)
    this.setRefundOrderId(this.currentOrder.id)
    this.setRefundOrderTableId(this.currentOrder.table)
    this.$router.push({ name: 'Order', params: { id: 'new',tableId: null, referenceId:this.currentOrder.id, refund:true } })
    },
    async refund () {
      this.$bvModal.show("processing-modal");
      let isError = false;
      const paymentObjects = [];
      try {
        // eslint-disable-next-line no-unused-vars
        for (const payment of this.currentOrder.payments) {
          const amount = 0 - (payment.amount - payment.change_amount);
          const current_payment_type = this.terminal.payment_types.find(py => py.name === payment.payment_type);
          let result;
          if (!current_payment_type) {
            this.error.title = "Payment type is not found";
            this.error.info = "Payment type is not available at current terminal";
            isError = true;
            break;
          }
          const behavior = current_payment_type.behavior;
          if (behavior === PAYMENT_BEHAVIOR.NABANCARD_INTEGRATION) {
            // NA payment
            // try void
            try {
              result = await makeNAVoid(current_payment_type.url, payment.processor_response);
              if (result && result.status === "error") {
                throw Error("Could not refund");
              }
            } catch (e) {
              console.error("Could not void");
              console.error(e);
              isError = true;
            }
            // try refund
            if (!result || (result && result["status"] === "error")) {
              try {
                result = await makeNARefund(current_payment_type.url, payment.processor_response);
                if (result && result.status === "error") {
                  throw Error("Could not refund");
                }
              } catch (e) {
                console.error("Could not refund");
                console.error(e);
                isError = true;
              }
            }
            if (!result || (result && result["status"] === "error")) {
              console.error("Can not refund");
              this.error.title("Can not refund");
              this.error.info("Can not refund, contact administrator");
              isError = true;
            }
            // NA payment end
          }
          if (!isError) {
            paymentObjects.push({
              order: payment.order,
              employee: payment.employee,
              amount: amount,
              amount_paid: amount,
              tips: payment.tips,
              change_amount: 0,
              payment_type: payment.payment_type,
              payment_date: new Date().toISOString(),
              related_terminal: this.terminal.id,
              transaction_type: TRANSACTION_TYPE.RETURN,
              processor_refund_response: result && result.response ? result.response : "",
              card_lastfour: null,
              local_id: `${this.terminal.id}_${this.currentOrder.payments.length + 1 + paymentObjects.length}`,
              shift: this.currentShift.id
            });
          }

        }
      } catch (e) {
        console.error(e);
        isError = true;
      }
      if (isError) {
        this.$bvModal.show("modal-error-checkout");
      } else {
        this.currentOrder.status = ORDER_STATUS.REFUNDED;
        this.currentOrder.payments = [...this.currentOrder.payments, ...paymentObjects];
        paymentObjects.map(async (paymentObject) => {
          await this.savePaymentToShift({ name: paymentObject.payment_type, amount: paymentObject.amount }, "refund");
        });
        this.$store.dispatch("orders/saveOrder", this.currentOrder);
        this.$bvModal.show("success-action--modal");
      }
      await this.$bvModal.hide("processing-modal");
      await this.$bvModal.hide("processing-modal");

    },
    async searchByNumber (searchValue=null) {

      const id = searchValue ? searchValue : this.searchValue;
      if (isNaN(id)) {
        if (!id.includes("_")) return this.searchError();
        return this.localSearch(id);
      }
      if (!navigator.onLine) return this.localSearch(id);

      // Server lookup disabled - use local data only
      // try {
      //   const order = await this.fetchOrderById(id);
      //   ...
      // }
      const order = this.$store.getters["orders/getOrderByIdOrLocalId"](id);
      if (order && order.id) {
        if (order.status !== this.statusFilter) {
          this.statusFilter = order.status;
          await this.$nextTick();
          setTimeout(() => {
            this.viewOrder(order);
          }, 300);
        } else {
          this.viewOrder(order);
        }
        this.searchValue = "";
      } else {
        return this.searchError();
      }
    },
    localSearch (id) {
      const orders = this.orderList.filter(order => order.id == id);
      if (!orders.length) return this.searchError();

      this.currentOrder = orders[0];

      return this.searchValue = "";
    },
    searchError () {
      sound.play();
      this.infoModal.text = "Order not found";
      this.$bvModal.show("info-modal");

      return this.searchValue = "";
    },
    receiveMessage (event) {
      const self = this;
      self.updateLocalId(event.data);
    },
    startTimer () {
      const vm = this;
      // Track the interval id so beforeDestroy can clear it. (Previously this
      // interval referenced an undefined `value`, so it never self-cleared and
      // leaked a 50ms timer for the lifetime of the page.)
      this.startupTimer = setInterval(function () {
        vm.timer += 2;
        if (vm.timer >= 180) {
          clearInterval(vm.startupTimer);
          vm.startupTimer = null;
        }
      }, 50);
    },
    updateLocalId: function (msgObj) {
      if (this.currentOrder.id === msgObj.localID) {
        this.currentOrder.id = msgObj.remoteID;
      }
    },
    viewOrder: function (viewOrder) {
      this.sidebarMob = false;
      this.isScrolled = true

      // Try to find the order in orderList first
      let currentOrder = this.orderList.find(order => order.id === viewOrder.id);

      // If not found in orderList, try to find in orders (local store)
      if (!currentOrder) {
        currentOrder = this.orders.find(order =>
          (order.id && order.id === viewOrder.id) ||
          (order.local_id && order.local_id === viewOrder.local_id)
        );
      }

      // If still not found, use the viewOrder directly (might be freshly fetched from backend)
      if (!currentOrder) {
        currentOrder = viewOrder;
      }

      if (currentOrder && currentOrder.status === ORDER_STATUS.COMPLETED) {
        currentOrder = this.applyRefundStatus(currentOrder);
      }
      this.currentOrder = currentOrder;

      // Update URL with orderId query parameter
      if (viewOrder.id) {
        // Check if we need to update the URL
        const currentOrderId = this.$route.query.orderId;
        if (currentOrderId !== viewOrder.id.toString()) {
          this.$router.replace({
            name: "OrdersList",
            query: { orderId: viewOrder.id }
          }).catch(err => {
            // Ignore navigation duplicated error
            if (err.name !== 'NavigationDuplicated') {
              console.error('Navigation error:', err);
            }
          });
        }
      }
    },
    isOrderSelected: function (order) {
      // Check if this order matches the currently selected order
      if (!this.currentOrder || !this.currentOrder.id) return false;

      // Compare by ID or local_id
      if (order.id && this.currentOrder.id) {
        return order.id === this.currentOrder.id;
      }
      if (order.local_id && this.currentOrder.local_id) {
        return order.local_id === this.currentOrder.local_id;
      }
      return false;
    },
    convertDate: function (date) {
      return date ? this.$moment(date).format("D MMMM YYYY hh:mmA") : "";
    },
    calculateDiscount: function (itemPrice, discount, item, order) {
      // Calculate total base price (product + modifiers)
      let totalBase = itemPrice;
      if (item && item.modifiers && Array.isArray(item.modifiers)) {
        const modsSum = item.modifiers
          .filter(m => !m.void_status)
          .reduce((sum, m) => sum + (m.price_original || 0), 0);
        totalBase += modsSum;
      }

      // For order-level discounts, use wholeDiscount instead of discount
      let totalDiscount = discount || 0;

      // Check if this is an order-level discount
      if (item && typeof item.wholeDiscount === 'number' && item.wholeDiscount !== 0) {
        // Order-level discount: use orderDiscountRatio to calculate percentage
        if (typeof item.orderDiscountRatio === 'number' && item.orderDiscountRatio !== 0) {
          totalDiscount = totalBase * item.orderDiscountRatio;
        } else {
          // Fallback: use wholeDiscount (product portion only)
          totalDiscount = item.wholeDiscount;
        }
      } else if (order && order.discount_orders_raw_value && (!discount || discount === 0)) {
        // For completed orders loaded from DB, check if there's an order-level discount
        // discount_orders_raw_type: 1 = percentage, 2 = fixed amount
        if (order.discount_orders_raw_type === 1) {
          // Percentage discount - just return the percentage value
          return order.discount_orders_raw_value;
        } else if (order.discount_orders_raw_type === 2) {
          // Fixed amount discount - need to calculate percentage based on order subtotal BEFORE discount
          const orderSubtotalAfterDiscount = order.subtotal || 1;
          const orderSubtotalBeforeDiscount = orderSubtotalAfterDiscount + order.discount_orders_raw_value;
          totalDiscount = totalBase * (order.discount_orders_raw_value / orderSubtotalBeforeDiscount);
        }
      }

      if (!totalDiscount || totalDiscount === 0) return 0;
      if (totalBase === 0) return 100;

      // Calculate percentage
      let percentage = (totalDiscount / totalBase * 100);

      // Round to avoid floating point precision issues and display rounding
      // If the percentage is very close to a whole number (within 0.02), round to that whole number
      // This handles cases like 39.99% -> 40%, 49.98% -> 50%, etc.
      const rounded = Math.round(percentage);
      if (Math.abs(percentage - rounded) < 0.02) {
        percentage = rounded;
      } else {
        // Otherwise, round to 2 decimal places
        percentage = Math.round(percentage * 100) / 100;
      }

      return percentage;
    },
    calculateItemTotalDiscount: function (item, order) {
      // Calculate item-level discount
      const itemDiscount = (item.discount || 0) * Math.abs(item.quantity);

      // Calculate whole order discount portion for this item
      let wholeDiscount = 0;

      // Check for discountPropotion (old method)
      if (item.discountPropotion && item.discountPropotion > 0) {
        wholeDiscount = item.discountPropotion * Math.abs(item.quantity);
      }
      // Check for wholeDiscount (new method in applyWholeOrderDiscount)
      else if (item.wholeDiscount && item.wholeDiscount > 0) {
        wholeDiscount = item.wholeDiscount * Math.abs(item.quantity);
      }
      // For completed orders loaded from DB, calculate from order-level discount
      else if (order && order.discount_orders_raw_value && (!item.discount || item.discount === 0)) {
        // Calculate total base price (product + modifiers)
        let totalBase = item.price || 0;
        if (item.modifiers && Array.isArray(item.modifiers)) {
          const modsSum = item.modifiers
            .filter(m => !m.void_status)
            .reduce((sum, m) => sum + (m.price_original || 0), 0);
          totalBase += modsSum;
        }

        // discount_orders_raw_type: 1 = percentage, 2 = fixed amount
        if (order.discount_orders_raw_type === 1) {
          // Percentage discount
          wholeDiscount = (totalBase * (order.discount_orders_raw_value / 100)) * Math.abs(item.quantity);
        } else if (order.discount_orders_raw_type === 2) {
          // Fixed amount discount - calculate this item's proportion
          // Need to use subtotal BEFORE discount was applied
          const orderSubtotalAfterDiscount = order.subtotal || 1;
          const orderSubtotalBeforeDiscount = orderSubtotalAfterDiscount + order.discount_orders_raw_value;
          wholeDiscount = (totalBase * (order.discount_orders_raw_value / orderSubtotalBeforeDiscount)) * Math.abs(item.quantity);
        }
      }

      // Total discount for this item
      const totalDiscount = itemDiscount + wholeDiscount;

      return totalDiscount.toFixed(2);
    },
    calculateItemTotalPrice: function (item) {
      // Calculate total price (product + modifiers)
      let totalPrice = item.price || 0;

      if (item.modifiers && Array.isArray(item.modifiers)) {
        const modsSum = item.modifiers
          .filter(m => !m.void_status)
          .reduce((sum, m) => sum + (m.price || m.price_original || 0), 0);
        totalPrice += modsSum;
      }

      return totalPrice.toFixed(2);
    },
    calculateOrderTotalDiscount: function (order) {
      if (!order || !order.items || !Array.isArray(order.items)) {
        return "0.00";
      }

      let totalDiscount = 0;

      // Sum up discounts from all items (including modifiers for order-level discounts)
      order.items.forEach(item => {
        if (item.void_status === 0 || item.void_status === null) {
          // Use calculateItemTotalDiscount which already handles both item-level and order-level discounts
          const itemDiscount = parseFloat(this.calculateItemTotalDiscount(item, order));
          totalDiscount += itemDiscount;
        }
      });

      return totalDiscount.toFixed(2);
    },
    isDisplayPaymentDetailsList: function () {
      return this.displayPaymentDetailsList = !this.displayPaymentDetailsList;
    },
    resetCurrentOrder() {
      this.currentOrder = {
        id: 0,
        localID: 0,
        subtotal: 0,
        tax_total: 0,
        grand_total: 0,
        items: [],
        table: null,
        status: null
      }
    },
    // Returns a shallow clone of a completed order annotated with
    // calculated_balance and isFullyRefund (balance includes related refund
    // orders). Pure: it does not mutate the passed order or any store object.
    // Drives the "Fully Refunded" state of the refund button on currentOrder.
    applyRefundStatus (order) {
      if (!order) return order;
      const offlineRefundedOrders = this.orders.filter(o => !o.id && o.status === ORDER_STATUS.REFUNDED);
      const refundedOrders = [...this.refundedOrdersList, ...offlineRefundedOrders];

      let balance = order.grand_total || 0;
      const relatedRefunds = refundedOrders.filter(refOrder =>
        (refOrder.reference_order == order.id || refOrder.reference_order == order.local_id) &&
        refOrder.status === ORDER_STATUS.REFUNDED
      );
      relatedRefunds.forEach(refOrder => {
        balance += parseFloat(refOrder.grand_total || 0);
      });

      return { ...order, calculated_balance: balance, isFullyRefund: balance <= 0.01 };
    },
    showCollapse(index) {
      return this.itemsAtCurrentOrder.length > 0 && this.itemsAtCurrentOrder.length - 1 === index
    },
    getItemDisplayName(item) {
      // Shared, pure resolver (Step 2); honors the kitchen_name_pos setting.
      return resolveItemDisplayName(item, this.terminal, this.products);
    },
  }
};
</script>

<style lang="scss">
.section {
  padding-top: 0 !important;
}

.orders-bottom-options {
  border-bottom: 1px solid #e0e0e0;
}


.list-complete-item {
  transition: all .5s;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.popup-price {

  .modal-dialog {
    max-width: 440px;
  }

  .modal-body {
    padding: 30px 44px;

    @media (max-width: 767.98px) {
      padding: 25px 12px;
    }
  }

  .modal-header {
    background: #FAFAFA;
    align-items: center;
    position: relative;
    justify-content: center;
    height: 72px;

    .btn {
      min-width: 84px;
      position: absolute;
      left: 16px;
      top: 50%;
      margin-top: -20px;

      @media (max-width: 767.98px) {
        left: 12px;
      }
    }

    h5 {
      margin: 0px;
      text-align: center;
    }
  }

  .modal-footer {

    border: none;
    position: absolute;
    width: 130px;
    text-align: center;
    top: 0;
    bottom: 0;
    background: #EBEBEB;
    border-radius: 0px 10px 10px 0px;
    right: -130px;
    border-left: 3px solid #2A7BFF;
    padding: 0px;
    align-items: flex-start;
    overflow: hidden;
    height: 100%;

    .w-100 {
      height: 100%;
    }

    h5 {
      font-size: 16px;
      line-height: 19px;
      color: rgba(74, 74, 74, 0.717108);
      background: #FAFAFA;
      height: 71px;
      line-height: 71px;
      margin: 0px;
      width: 100%;
    }

    ul {
      overflow-y: auto;
      height: calc(100% - 71px);

      li {
        padding: 1px 0;
      }

      a {
        display: block;
        height: 72px;
        width: 100%;
        font-size: 15px;
        line-height: 21px;
        color: #1E1E1E;
        text-decoration: none;
        background: #fff;
        transition: all .2s ease-in-out;
        padding: 10px;

        &.active,
        &:hover {
          background: #2889FA;
          color: #fff;
        }

        span {
          display: block;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .discount-item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 72px;
        width: 100%;
        font-size: 15px;
        line-height: 21px;
        color: #1E1E1E;
        text-decoration: none;
        background: #fff;
        transition: all .2s ease-in-out;
        padding: 10px;
        cursor: pointer;

        &.active,
        &:hover {
          background: #2889FA;
          color: #fff;
        }
      }


    }
  }

  &-sidebar {
    .modal-content {
      border-radius: 10px 0px 0px 10px;
    }

    .modal-header {
      border-radius: 10px 0px 0px 0rem;
    }

    .modal-body {
      border-radius: 0rem 0px 0px 10px;
    }
  }
}


.modifiers-sidebar-backdrop {
  background: #212121;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  opacity: .5;
  z-index: 10;

  transition: all .2s ease;
}

.modifiers-sidebar-backdrop[aria-pressed="false"] {
  opacity: 0;
  z-index: -1;
}


.slide-enter-active,
.slide-leave-active {
  left: 0;
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  left: 100%;
  transition: all .15s ease-in 0s;
}


@media (max-width: 767.98px) {
  .list-complete-item,
  .modifiers-sidebar-backdrop,
  .slide-enter-active,
  .slide-leave-active,
  .slide-enter,
  .slide-leave-to {
    transition: none !important;
  }
}


.modifiers-sidebar-panel {
  position: absolute;
  z-index: 100;
  top: 0;
  background: #eeeeee;
  left: 0;
  width: 100%;
  bottom: 0;
}

.order-sum {
  background-color: #fff;
  color: #2c3e50;
  height: 60px;
  font-size: 1.375rem;
  line-height: 1.875rem;
  padding: 15px 16px;
}

.icon-dot{
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50px;
}
.order-list-container {
  .v-spinner {
    height: 100% !important;
  }
}
.ol-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 6px 4px 16px;
}

.ol-empty {
  padding: 32px 16px;
  font-size: 15px;
}

.ol-card {
  background: #fff;
  color: #1E1E1E;
  border: 1px solid #e6e6e6;
  border-left: 4px solid #d0d0d0;
  border-radius: 8px;
  padding: 14px 16px;
  cursor: pointer;
  transition: box-shadow .15s ease, border-color .15s ease, background-color .15s ease;

  &:hover {
    border-color: #c4c4c4;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &.active {
    border-color: #2A7BFF;
    background: #f0f6ff;
    box-shadow: 0 2px 10px rgba(42, 123, 255, 0.12);
  }

  &.accent-open { border-left-color: #2A7BFF; }
  &.accent-hold { border-left-color: #F5A623; }
  &.accent-completed { border-left-color: #2E9E5B; }
  &.accent-cancelled { border-left-color: #9e9e9e; }
  &.accent-refunded { border-left-color: #E2574C; }
}

.ol-header {
  display: grid;
  grid-template-columns: minmax(180px, auto) minmax(0, 1fr) auto;
  align-items: flex-start;
  gap: 12px;
}

.ol-header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  grid-column: 1;
}

.ol-id {
  font-size: 16px;
  font-weight: 700;
  color: #1E1E1E;
}

.ol-customer {
  font-size: 14px;
  color: #4a4a4a;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  grid-column: 2;
}

.ol-amount {
  display: flex;
  flex-direction: column;
  text-align: right;
  line-height: 1.2;
  white-space: nowrap;
  grid-column: 3;
}

.ol-amount-label {
  font-size: 12px;
  color: #8a8a8a;
}

.ol-amount-value {
  font-size: 18px;
  font-weight: 700;
  color: #1E1E1E;
}

.ol-meta-line {
  margin-top: 8px;
  font-size: 13px;
  color: #6b6b6b;
  line-height: 1.4;

  &.hold {
    color: #8a5a00;
    font-style: italic;
  }
}

.ol-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px 16px;
  margin-top: 14px;
}

.ol-info {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 28px;
  flex: 1 1 260px;
  min-width: 0;
}

.ol-info-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.ol-info-label {
  font-size: 12px;
  color: #8a8a8a;
}

.ol-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1E1E1E;

  &.serve {
    color: #C0392B;
  }
}

.ol-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 0 0 auto;
}

.view-customer-btn {
  white-space: nowrap;
}

.ol-status-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .3px;
  white-space: nowrap;

  &.paid {
    background: #e6f4ea;
    color: #1e7e34;
  }

  &.unpaid {
    background: #fdecea;
    color: #c0392b;
  }
}

.order-source-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .3px;
  white-space: nowrap;
  vertical-align: middle;

  &.online {
    background: #f3ebff;
    color: #6f42c1;
  }

  &.dining {
    background: #e8f4fd;
    color: #1a73b8;
    text-transform: none;
    letter-spacing: 0;
    font-size: 12px;
  }
}

</style>
